import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Card, Table, Loader, Label} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import SearchFormMany from './SearchFormMany';
import QueryTable from './QueryTable';
import './styles.scss';

const INITIAL_STATE = {
  'initDate': null,
  'endDate': null,
  'bulletinId': '',
  'model': '',
  'subject': '',
  'type': 'TODOS',
  'filteredRows': [],
};

class BulletinQuery extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.BulletinQuery,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
  }

  componentWillUnmount() {
    this.props.clearBulletinList();
  }

  buildParams = () => {
    const {initDate, endDate, bulletinId, model, subject, type} = this.state;
    const params = {
      'initDate': initDate ? moment(initDate).format(noTimeZoneShortISODate) : null,
      'endDate': endDate ? moment(endDate).format(noTimeZoneShortISODate) : null,
      bulletinId,
      model,
      type,
      subject,
    };
  
    return params;
  };

  handleSearch = () => {
    const params = this.buildParams();
    this.props.fetchBulletins(params);
  };

  handleClear = () => {
    this.setState(INITIAL_STATE);
    this.props.clearBulletinList();
  };

  handleChange = (field, value) => {
    this.setState({[field]: value});
  };

  renderLoader() {
    return (
      <Table striped className="toyota-grid">
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan="100%">
              <Loader active inline="centered" content="Ejecutando" />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {bulletins, loading} = this.props;
    const {filteredRows} = this.state;

    return (
      <div className="bulletin-container">
        <Card raised fluid>
          <div className="title-bar">
            <div className="title">
              <h2>Consulta de Boletines</h2>
              <Label className="bulletin-total" size='large' color="green">
                Boletines encontrados
                <Label.Detail>{filteredRows.length}</Label.Detail>
              </Label>
            </div>
          </div>
        </Card>
        <Card raised fluid className="bulletin-form">
          <SearchFormMany
            {...this.state}
            handleChange={this.handleChange}
            handleClear={this.handleClear}
            handleSearch={this.handleSearch}
          />
        </Card>
        <Card raised fluid className="bulletin-table">
          {loading ? (
            this.renderLoader()
          ) : (
            <QueryTable
              list={bulletins}
              handleChange={this.handleChange}
              filteredRows={filteredRows}
              loading={loading}
            />
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'dealer': state.session.dealerId,
    'bulletins': state.BulletinQuery.list,
    'loading': state.BulletinQuery.loading,
  };
};

const {clearBulletinList, fetchBulletins, withRouter, navigateTo} = Actions;

const mapDispatchToProps = {
  clearBulletinList,
  fetchBulletins,
  navigateTo,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BulletinQuery)
);
